import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  StyleSheet,
  View,
  Text,
  FlatList,
  SafeAreaView,
  useWindowDimensions,
  Platform,
  TextInput,
} from "react-native";
import { useTheme } from "@react-navigation/native";
import { createCommonStyles } from "../../../styles/commonStyles";
import { ActivityIndicator, Card, Checkbox, Picker } from "react-native-paper";
import CustomInput from "../../../components/CustomInput";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import CustomButton from "../../../components/CustomButton";
import { useLeaveSchemes } from "../../../hooks/useLeaveSchemes";
import { useTranslation } from "react-i18next";
import { useTableHelper } from "../../../hooks/useTableHelper";
import CustomDropDownWithIcons from "../../../components/CustomDropDownWithIcons/CustomDropDownWithIcons";
import { ScrollView } from "react-native-gesture-handler";
import Swal from "sweetalert2";
import { Image } from "react-native";
import { useCompany } from "../../../hooks/useCompany";
import { DEFAULTPROFILE } from "../../../img/DefaultProfile";
import Ionicons from "@react-native-vector-icons/ionicons/static";


const FlatListView = React.memo(({ item, index, styles, showCF, onDelete, onChnageField }) => {
  return (
    <SafeAreaView style={{ flex: 1, alignContent: "flex-start", margin: 8 }}>
      <SafeAreaView style={[styles.row, { flexWrap: "nowrap", alignItems: "center" }]}>
        {/* //* Always Visible */}

        <View style={{ flex: 2, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.label}
            editable={true}
            type="MAININPUT"
            multiline={true}
            numberOfLines={2}
            setValue={(val) => onChnageField(index, "label", val)}
          />
        </View>

        <View style={{ flex: 2, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.text}
            editable={true}
            type="MAININPUT"
            multiline={true}
            numberOfLines={2}
            setValue={(val) => onChnageField(index, "text", val)}
          />
        </View>

        <View style={{ width: 120, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.valueField}
            editable={true}
            type="MAININPUT"
            setValue={(val) => onChnageField(index, "valueField", val)}
          />
        </View>

        {showCF && (
          <View style={{ width: 120, marginHorizontal: 10 }}>
            <CustomInput
              value={item?.maxcf}
              editable={true}
              type="MAININPUT"
              setValue={(val) => onChnageField(index, "maxcf", val)}
            />
          </View>
        )}

        <View style={{ width: 120, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.workunitsperweek}
            editable={true}
            type="MAININPUT"
            setValue={(val) => onChnageField(index, "workunitsperweek", val)}
          />
        </View>

        <View style={{ width: 120, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.boundary}
            editable={true}
            type="MAININPUT"
            setValue={(val) => onChnageField(index, "boundary", val)}
          />
        </View>

        <View style={{ width: 120, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.total1}
            editable={true}
            type="MAININPUT"
            setValue={(val) => onChnageField(index, "total1", val)}
          />
        </View>

        <View style={{ width: 120, marginHorizontal: 10 }}>
          <CustomInput
            value={item?.total2}
            editable={true}
            type="MAININPUT"
            setValue={(val) => onChnageField(index, "total2", val)}
          />
        </View>

        <CustomButton
          iconName="trash-outline"
          onPress={() => onDelete(item)}
          show="HOME_BELL"
          type="HOME_BELL"
          textTop="2"
          sz={30}
        />
      </SafeAreaView>
    </SafeAreaView>
  );
});
const HRAdminLeaveSchemeScreen = ({ selectedCompany }) => {
  const props = {
    Editable: 1,
  };
  const { width, height } = useWindowDimensions();
  const { colors } = useTheme();
  const styles = makeStyles(colors, width, height);
  const common = createCommonStyles(colors);
  const [initialState, setInitialState] = useState([]);
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [parameter, SetParameter] = useState("");
  const [leaveUnits, setLeaveUnits] = useState("");
  const [ruleOptions, setRuleOptions] = useState([]);
  const [selectedRule, setSelectedRule] = useState("");
  const [ruleValue, setRuleValue] = useState("");
  const [expOptions, setExpOptions] = useState([]);
  const [workUnitsOptions, setWorkUnitsOptions] = useState([]);
  const [selectedWorkUnit, setSelectedWorkUnit] = useState("");
  const [selectedExp, setSelectedExp] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  const [showCriteria, setShowCriteria] = useState(false);
  const [criteriaOptions, setCriteriaOptions] = useState([]);
  const [selectedCriterion, setSelectedCriterion] = useState("");
  const [criteriaFilteringOptions, setCriteriaFilteringOptions] = useState([]);
  const [selectedCriteriaFiltering, setSelectedCriteriaFiltering] =
    useState(null);
  const [leaveSchemeParams, setLeaveSchemeParams] = useState([]);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [searchTermTwice, setSearchTermTwice] = useState('');
  const [searchTermNotIncluded, setSearchTermNotIncluded] = useState('');

  const [total1, setTotal1] = useState("");
  const [total2, setTotal2] = useState("");
  const [maxcf, setMaxcf] = useState("");

  const [boundary, setBoundary] = useState("");
  const [appliedFiltersStr, setAppliedFiltersStr] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [includedTwice, setIncludedTwice] = useState([]);
  const [notIncluded, setNotIncluded] = useState([]);

  //* validation errorst
  const [leaveUnitsError, setLeaveUnitsError] = useState("");
  const [boundaryError, setBoundaryError] = useState("");
  const [valueError, setValueError] = useState("");
  const [maxcfError, setMaxcfError] = useState("");

  const [changedRows, setChangedRows] = useState(new Set());
  const [isSaving, setIsSaving] = useState(false);
  const [originalLeaveSchemeParams, setOriginalLeaveSchemeParams] = useState([]);

  const leaveSchemeData = {
    company: selectedCompany,
    key: "", //from rule
    expr: "",
    additionalcriteria: "",
    additionalcriteriadescr: "",
    text: "",
    value: 0.0,
    rowguid: null,
    acode: "", //retrieved from leave type
    maxcf: 0.0,
    workunitsperweek: 0.0,
    shortleavemax: 0.0,
    shortleavetotal: 0.0,
    totalleavemax: 0.0,
    prorata: false,
    datecol: null,
  };
  const {
    error,
    isLoading: leaveSchemeLoading,
    getLeaveTypes,
    getLeaveSchemesRules,
    getLeaveSchemesCriteria,
    getLeaveSchemesWorkUnits,
    insertLeaveScheme,
    deleteLeaveScheme,
    getLeaveSchemesEmployeesIncludedTwice,
    getLeaveSchemesEmployeesNotIncluded,
    getLeaveSchemesParams,
    postRecreateLeaveAnalysisForEmployees,
  } = useLeaveSchemes();
  const [changes, setChanges] = useState({});
  const [refreshAfterSave, setRefreshAfterSave] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showCF, setShowCF] = useState(false);
  //refs
  const companyRef = useRef(null);
  const selectedLeaveTypeRef = useRef(null);
  const selectedRuleRef = useRef(null);
  const parameterRef = useRef(null);
  const selectedExpRef = useRef(null);
  const submitClickedRef = useRef(null);
  const workUnitsRef = useRef(null);
  const filteringRef = useRef(null);
  // * Language
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!refreshAfterSave && companyRef.current === selectedCompany) return;

    companyRef.current = selectedCompany;
    setIsLoading(true); // Set loading to true before fetching data

    getLeaveTypes(selectedCompany)
      .then((arr) => {
        let data = arr.map((item) => ({
          label: item.description,
          value: item.rowGuid,
          code: item.aCode,
          canCF: item.canCF,
        }));
        setLeaveTypeOptions(data);
        setChanges({});
        setIsLoading(false); // Set loading to false after data is fetched
      })
      .catch((err) => {
        console.error("Error fetching leave types data:", err);
        setRefreshAfterSave(false);
        setIsLoading(false);
      });

    getLeaveSchemesRules()
      .then((arr) => {
        let data = arr.map((item) => ({
          label: item.displayMember,
          value: item.rowGuid,
          date: item.datecol,
          valueMember: item.valueMember,
        }));
        setRuleOptions([...data]);
        setIsLoading(false); // Set loading to false after data is fetched
      })
      .catch((err) => {
        console.error("Error fetching rules", err);
        setRefreshAfterSave(false);
        setIsLoading(false);
      });

    getLeaveSchemesCriteria(selectedCompany)
      .then((arr) => {
        let data = arr.map((item) => ({
          label: item.displayMember,
          value: item.rowGuid,
          cFiltering: JSON.parse(item.options),
          vMember: item.valueMember,
        }));
        //console.log('DATA:\n'+JSON.stringify(data))


        setCriteriaOptions(data);
        setIsLoading(false); // Set loading to false after data is fetched
        //setSelectedRule(rules.at(0));
      })
      .catch((err) => {
        console.error("Error fetching rules", err);
        setRefreshAfterSave(false);
        setIsLoading(false);
      });

    try {
      var data = [
        {
          label: "More than",
          value: "GUID-1",
          condition: ">",
        },
        {
          label: "Less than",
          value: "GUID-2",
          condition: "<",
        },
        {
          label: "More or Equal",
          value: "GUID-3",
          condition: ">=",
        },
        {
          label: "Less or Equal ",
          value: "GUID-4",
          condition: "<=",
        },
        {
          label: "Equal to",
          value: "GUID-5",
          condition: "=",
        },
        // Add more objects as needed
      ];

      // Update state with the processed data
      setExpOptions(data);
      setIsLoading(false); // Set loading to false after data is fetched
    } catch (err) {
      console.error("Error fetching params", err);
      setRefreshAfterSave(false);
      setIsLoading(false);
    }

    getLeaveSchemesWorkUnits()
      .then((arr) => {
        let data = arr.map((item) => ({
          label: item.workUnits,
          value: item.rowGuid,
        }));
        setWorkUnitsOptions(data);
        setIsLoading(false); // Set loading to false after data is fetched
      })
      .catch((err) => {
        console.error("Error fetching work units", err);
        setRefreshAfterSave(false);
        setIsLoading(false);
      });
  }, [selectedCompany, refreshAfterSave]);

  useEffect(() => {
    if (submitClickedRef !== null && submitClicked === false) {
      clearValues();
    }
    submitClickedRef.current = submitClicked;
  }, [submitClicked]);

  useEffect(() => {
    selectedLeaveTypeRef.current = selectedLeaveType;
    const selectedItem = leaveTypeOptions.find(
      (item) => item.value === selectedLeaveType
    );
    if (selectedItem) {

      getLeaveSchemesEmployeesIncludedTwice(selectedItem.code, selectedCompany)
        .then((arr) => {
          let data = arr.map((item) => ({
            label: item.name,
            value: item.rowGuid,
            employeeid: item.employeeid ?? item.employeeID ?? item.employeeId,
          }));
          setIncludedTwice(data);
          setIsLoading(false); // Set loading to false after data is fetched
        })
        .catch((err) => {
          console.error("Error fetching included twice", err);
          setRefreshAfterSave(false);
          setIsLoading(false);
        });

      getLeaveSchemesEmployeesNotIncluded(selectedItem.code, selectedCompany)
        .then((arr) => {
          let data = arr.map((item) => ({
            label: item.name,
            value: item.rowGuid,
            employeeid: item.employeeid ?? item.employeeID ?? item.employeeId,
          }));
          setNotIncluded(data);
          setIsLoading(false); // Set loading to false after data is fetched
        })
        .catch((err) => {
          console.error("Error fetching not  included", err);
          setRefreshAfterSave(false);
          setIsLoading(false);
        });
      if (selectedItem.canCF === true) {
        setShowCF(true);
      } else setShowCF(false);

      getLeaveSchemesParams(selectedCompany, selectedItem.code)
        .then((arr) => {
          let data = arr.map((item) => ({
            label: item.additionalcriteriadescr,
            value: item.rowguid,
            text: item.text,
            valueField: item.value,
            maxcf: item.maxcf,
            workunitsperweek: item.workunitsperweek,
            boundary: item.shortleavemax,
            total1: item.shortleavetotal,
            total2: item.totalleavemax,
            acode: item.acode,
            key: item.key,
            expr: item.expr,
            additionalcriteria: item.additionalcriteria,
            prorata: item.prorata,
            datecol: item.datecol,
          }));
          setLeaveSchemeParams(data);
          setOriginalLeaveSchemeParams(data);
          setChangedRows(new Set());
          setIsLoading(false); // Set loading to false after data is fetched
        })
        .catch((err) => {
          console.error("Error fetching not  included", err);
          setRefreshAfterSave(false);
          setIsLoading(false);
        });
    }
  }, [selectedLeaveType]);

  useEffect(() => { }, [ruleValue]);
  useEffect(() => { }, [includedTwice]);
  useEffect(() => { }, [notIncluded]);

  useEffect(() => { }, [showCF]);
  useEffect(() => {
    selectedRuleRef.current = selectedRule;
  }, [selectedRule]);

  useEffect(() => { }, [appliedFiltersStr, appliedFilters]);
  useEffect(() => {
    const selectedItem = criteriaOptions.find(
      (item) => item.value === selectedCriterion
    );
    if (selectedItem) {
      let data = selectedItem.cFiltering.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setCriteriaFilteringOptions(data);
    }
  }, [selectedCriterion]);

  useEffect(() => {
    filteringRef.current = selectedCriteriaFiltering;
  }, [selectedCriteriaFiltering, setCriteriaFilteringOptions]);

  useEffect(() => { }, [boundary, total1, total2, maxcf]);

  useEffect(() => {
    workUnitsRef.current = selectedWorkUnit;
  }, [selectedWorkUnit]);

  useEffect(() => {
    selectedExpRef.current = selectedExp;
  }, [selectedExp]);

  useEffect(() => {
    parameterRef.current = parameter;
  }, [parameter]);

  useEffect(() => { }, [leaveUnits]);

  useEffect(() => { }, [selectedCompany]);
  useEffect(() => { }, [leaveSchemeParams]);

  // const toggleCheckbox = () => {
  //   if (props.Editable) {
  //     setProRata(!checkedProRata);
  //   }
  // };

  const clearValues = () => {
    setSubmitClicked(false);
    setSelectedLeaveType(null);
    setSelectedRule(null);
  };

  const handleChangeField = useCallback((index, field, value) => {
    setLeaveSchemeParams((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
    setChangedRows((prev) => {
      const next = new Set(prev);
      next.add(index);
      return next;
    });
  }, []);

  const handleSaveChanges = async () => {
    if (changedRows.size === 0) return;

    const leaveTypeItem = leaveTypeOptions.find(
      (lt) => lt.value === selectedLeaveType
    );

    setIsSaving(true);
    try {
      const rowsToSave = Array.from(changedRows).map((idx) => leaveSchemeParams[idx]);

      for (const row of rowsToSave) {
        const payload = {
          company: selectedCompany,
          key: row.key,
          expr: row.expr,
          additionalcriteria: row.additionalcriteria,
          additionalcriteriadescr: row.label,
          text: row.text,
          value: row.valueField,
          rowguid: row.value,
          acode: row.acode ?? leaveTypeItem?.code,
          maxcf: row.maxcf,
          workunitsperweek: row.workunitsperweek,
          shortleavemax: row.boundary,
          shortleavetotal: row.total1,
          totalleavemax: row.total2,
          prorata: row.prorata,
          datecol: row.datecol,
        };

        const success = await insertLeaveScheme(payload);
        if (!success) {
          throw new Error(`Failed to save row ${row.value}`);
        }
      }

      Swal.fire({
        title: "Saved",
        text: "Your changes were saved successfully.",
        icon: "success",
      });

      setChangedRows(new Set());

      if (leaveTypeItem) {
        getLeaveSchemesParams(selectedCompany, leaveTypeItem.code)
          .then((arr) => {
            let data = arr.map((item) => ({
              label: item.additionalcriteriadescr,
              value: item.rowguid,
              text: item.text,
              valueField: item.value,
              maxcf: item.maxcf,
              workunitsperweek: item.workunitsperweek,
              boundary: item.shortleavemax,
              total1: item.shortleavetotal,
              total2: item.totalleavemax,
              acode: item.acode,
              key: item.key,
              expr: item.expr,
              additionalcriteria: item.additionalcriteria,
              prorata: item.prorata,
              datecol: item.datecol,
            }));
            setLeaveSchemeParams(data);
            setOriginalLeaveSchemeParams(data);
          })
          .catch((err) => console.error("Error refreshing after save", err));
      }
    } catch (err) {
      console.error("Error saving changes", err);
      Swal.fire({
        title: "Error",
        text: "Could not save changes. Please try again.",
        icon: "error",
      });
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading || leaveSchemeLoading) {
    return (
      <View style={styles.loader}>
        <ActivityIndicator animating={true} color={colors.blue} />
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.loader}>
        <Text style={styles.error}>{t("common:errorLoadingData")}</Text>
      </View>
    );
  }

  const renderData =
    (item, index) => {
      return (
        <Card.Content>
          <FlatListView
            item={item}
            index={index}
            styles={styles}
            showCF={showCF}
            onDelete={handleDeleteRule}
            onChnageField={handleChangeField}
          />
        </Card.Content>
      );
    };
  //[]
  // );

  const applyFiltering = () => {
    // Create a new item with name and type

    const selectedItem = criteriaOptions.find(
      (item) => item.value === selectedCriterion
    );

    var appliedFilterItem = criteriaFilteringOptions.find(
      (item) => item.value === selectedCriteriaFiltering
    );

    if (selectedItem) {
      const formattedString = `•${selectedItem.label}-${appliedFilterItem.label}`;

      if (!appliedFiltersStr.includes(formattedString)) {
        setAppliedFiltersStr(appliedFiltersStr + formattedString + "\n");
        const newItem = {
          valueMember: selectedItem.vMember,
          val: selectedCriteriaFiltering,
          descr: selectedItem.label + ": " + appliedFilterItem.label,
        };
        setAppliedFilters((prevCriteria) => [...prevCriteria, newItem]);
      }
    }
  };
  const onChangeLeaveUnits = (leavUnits) => {
    // Filter input to allow only digits and a single decimal point
    const filteredUnits = leavUnits.replace(/[^0-9.]/g, "");
    const decimalCount = (filteredUnits.match(/\./g) || []).length;

    if (decimalCount > 1) {
      // If more than one decimal point, set error
      setLeaveUnitsError("Invalid units");
    } else if (filteredUnits === "") {
      // Allow clearing the input
      setLeaveUnits("");
      setLeaveUnitsError("Required entry-Input is can't be empty");
    } else {
      const newUnits = parseFloat(filteredUnits);
      if (!isNaN(newUnits) && newUnits >= 0) {
        setLeaveUnits(filteredUnits); // Update the units state with the filtered value
        setLeaveUnitsError("");
      } else {
        setLeaveUnitsError("Invalid units");
      }
    }
  };

  const onChangeBoundary = (boundary) => {
    // Filter input to allow only digits and a single decimal point
    const filteredBoundary = boundary.replace(/[^0-9.]/g, "");
    const decimalCount = (filteredBoundary.match(/\./g) || []).length;

    if (decimalCount > 1) {
      // If more than one decimal point, set error
      setBoundaryError("Invalid units");
    } else if (filteredBoundary === "") {
      // Allow clearing the input
      setBoundary("");
      setBoundaryError("Required entry-Input is can't be empty");
    } else {
      const newBoundary = parseFloat(filteredBoundary);
      if (!isNaN(newBoundary) && newBoundary >= 0) {
        setBoundary(filteredBoundary); // Update the units state with the filtered value
        setBoundaryError("");
      } else {
        setBoundaryError("");
        ("Invalid units");
      }
    }
  };

  const onChangeRuleValue = (val) => {
    // Filter input to allow only digits and a single decimal point
    const filtereVal = val.replace(/[^0-9.]/g, "");
    const decimalCount = (filtereVal.match(/\./g) || []).length;

    if (decimalCount > 1) {
      // If more than one decimal point, set error
      setValueError("Invalid units");
    } else if (filtereVal === "") {
      // Allow clearing the input
      setRuleValue("");
      setValueError("Required entry-Input is can't be empty");
    } else {
      const newval = parseFloat(filtereVal);
      if (!isNaN(newval) && newval >= 0) {
        setRuleValue(filtereVal); // Update the units state with the filtered value
        setValueError("");
      } else {
        setValueError("");
        ("Invalid rule value");
      }
    }
  };

  const onChangeMaxcf = (val) => {
    // Filter input to allow only digits and a single decimal point
    const filtereVal = val.replace(/[^0-9.]/g, "");
    const decimalCount = (filtereVal.match(/\./g) || []).length;

    if (decimalCount > 1) {
      // If more than one decimal point, set error
      setMaxcfError("Invalid maxcf");
    } else if (filtereVal === "") {
      // Allow clearing the input
      setMaxcf("");
      setMaxcfError("Required entry-Input is can't be empty");
    } else {
      const newval = parseFloat(filtereVal);
      if (!isNaN(newval) && newval >= 0) {
        setMaxcf(filtereVal); // Update the units state with the filtered value
        setMaxcfError("");
      } else {
        setMaxcfError("");
        ("Invalid rule value");
      }
    }
  };

  const onChangeTotal = (total, flag) => {
    // Filter input to allow only digits and a single decimal point
    const filteredTotal = total.replace(/[^0-9.]/g, "");
    const decimalCount = (filteredTotal.match(/\./g) || []).length;

    if (decimalCount > 1) {
      // If more than one decimal point, set error
      setTotalError("Invalid units");
    } else if (filteredTotal === "") {
      // Allow clearing the input
      if (flag == 1) setTotal1("");
      else setTotal2("");
    } else {
      const newtotal = parseFloat(filteredTotal);
      if (!isNaN(newtotal) && newtotal >= 0) {
        if (flag === 1) setTotal1(filteredTotal);
        else setTotal2(filteredTotal);
      }
    }
  };

  const handleCancelChanges = () => {
    setLeaveSchemeParams((prev) =>
      prev.map((row, idx) =>
        changedRows.has(idx) ? originalLeaveSchemeParams[idx] : row
      )
    );
    setChangedRows(new Set());
  };

  const handleDeleteRule = async (item) => {
    const confirmResult = await Swal.fire({
      title: "Remove this rule?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    const leaveTypeItem = leaveTypeOptions.find(
      (lt) => lt.value === selectedLeaveType
    );

    try {
      const success = await deleteLeaveScheme(item.value);
      if (success) {
        Swal.fire({
          title: "Removed",
          text: "The rule was removed successfully.",
          icon: "success",
        });

        getLeaveSchemesParams(selectedCompany, leaveTypeItem.code)
          .then((arr) => {
            let data = arr.map((p) => ({
              label: p.additionalcriteriadescr,
              value: p.rowguid,
              text: p.text,
              valueField: p.value,
              maxcf: p.maxcf,
              workunitsperweek: p.workunitsperweek,
              boundary: p.shortleavemax,
              total1: p.shortleavetotal,
              total2: p.totalleavemax,
              acode: p.acode,
              key: p.key,
              expr: p.expr,
              additionalcriteria: p.additionalcriteria,
              prorata: p.prorata,
              datecol: p.datecol,
            }));
            setLeaveSchemeParams(data);
            setOriginalLeaveSchemeParams(data);
            setChangedRows(new Set());
          })
          .catch((err) => console.error("Error refreshing rules after removal", err));

        getLeaveSchemesEmployeesIncludedTwice(leaveTypeItem.code, selectedCompany)
          .then((arr) => {
            let data = arr.map((emp) => ({
              label: emp.name,
              value: emp.rowGuid,
              employeeid: emp.employeeid ?? emp.employeeID ?? emp.employeeId,
            }));
            setIncludedTwice(data);
          })
          .catch((err) => console.error("Error refreshing included twice after removal", err));

        getLeaveSchemesEmployeesNotIncluded(leaveTypeItem.code, selectedCompany)
          .then((arr) => {
            let data = arr.map((emp) => ({
              label: emp.name,
              value: emp.rowGuid,
              employeeid: emp.employeeid ?? emp.employeeID ?? emp.employeeId,
            }));
            setNotIncluded(data);
          })
          .catch((err) => console.error("Error refreshing not included after removal", err));

      } else {
        Swal.fire({
          title: "Error",
          text: "Could not remove the rule. Please try again.",
          icon: "error",
        });
      }
    } catch (err) {
      console.error("Error removing rule", err);
      Swal.fire({
        title: "Error",
        text: "Could not remove the rule. Please try again.",
        icon: "error",
      });
    }
  };


  const handleSubmit = async () => {
    if (
      selectedLeaveType != null &&
      selectedRule != null &&
      leaveUnitsError == "" &&
      leaveUnits != "" &&
      // boundaryError == "" &&
      // boundary != "" &&
      valueError == "" &&
      ruleValue != "" &&
      // ((showCF && maxcfError == "" && maxcf != "") ||
      //   (!showCF && maxcfError == "")) &&
      selectedWorkUnit != "" &&
      selectedExp != "" &&
      selectedRule != "" //&&
      // total1 != "" &&
      // total2 != ""
    ) {

      const exprItem = expOptions.find((item) => item.value === selectedExp);
      if (exprItem) leaveSchemeData.expr = exprItem.condition + ruleValue;
      //>=0
      if (appliedFilters.length > 0) {
        var filters = "";
        var filtersDescr = "";
        appliedFilters.forEach(function (criterion) {
          const resolvedCriterion = criterion.valueMember.replace("@val", "N###" + criterion.val + "###").trim();
          filters += " " + resolvedCriterion + " ";
          filtersDescr += criterion.descr + " ";
        });
        leaveSchemeData.additionalcriteria = filters;
        leaveSchemeData.additionalcriteriadescr = filtersDescr;
        //>criteria creation
      }
      const ruleItem = ruleOptions.find((item) => item.value === selectedRule);
      if (ruleItem) {
        leaveSchemeData.text = ruleItem.label + leaveSchemeData.expr;
        leaveSchemeData.datecol = ruleItem.date;
        leaveSchemeData.key = ruleItem.valueMember;
      }
      //e.g Years working >=0

      const leaveTypeItem = leaveTypeOptions.find(
        (item) => item.value === selectedLeaveType
      );
      if (leaveTypeItem) leaveSchemeData.acode = leaveTypeItem.code;

      const workUnitItem = workUnitsOptions.find(
        (item) => item.value === selectedWorkUnit
      );
      if (workUnitItem) leaveSchemeData.workunitsperweek = workUnitItem.label;

      leaveSchemeData.value = leaveUnits;
      if (boundary != "") leaveSchemeData.shortleavemax = boundary; //limit-bound of continuous work units on short-time leave
      if (total1 != "") leaveSchemeData.shortleavetotal = total1; //maximum allowed short-time leave
      if (total2 != "") leaveSchemeData.totalleavemax = total2; //maximum regular work units for leaves
      if (showCF && maxcf != "") leaveSchemeData.maxcf = maxcf;

      var succes = await insertLeaveScheme(leaveSchemeData);
      if (succes) {
        Swal.fire({
          title: "Success!",
          text: "Your operation was completed successfully.",
          icon: "success",
          button: "OK",
        });

        if (leaveTypeItem.canCF === true) {
          setShowCF(true);
        } else {
          setShowCF(false);
        }

        getLeaveSchemesParams(selectedCompany, leaveTypeItem.code)
          .then((arr) => {
            let data = arr.map((item) => ({
              label: item.additionalcriteriadescr,
              value: item.rowguid,
              text: item.text,
              valueField: item.value,
              maxcf: item.maxcf,
              workunitsperweek: item.workunitsperweek,
              boundary: item.shortleavemax,
              total1: item.shortleavetotal,
              total2: item.totalleavemax,
              acode: item.acode,
              key: item.key,
              expr: item.expr,
              additionalcriteria: item.additionalcriteria,
              prorata: item.prorata,
              datecol: item.datecol,
            }));
            setLeaveSchemeParams(data);
            setOriginalLeaveSchemeParams(data);
            setIsLoading(false);
          })
          .catch((err) => {
            console.error("Error fetching not  included", err);
            setRefreshAfterSave(false);
            setIsLoading(false);
          });
        getLeaveSchemesEmployeesIncludedTwice(leaveTypeItem.code, selectedCompany)
          .then((arr) => {
            let data = arr.map((item) => ({
              label: item.name,
              value: item.rowGuid,
              employeeid: item.employeeid ?? item.employeeID ?? item.employeeId,
            }));
            setIncludedTwice(data);
          })
          .catch((err) => console.error("Error refreshing included twice", err));

        getLeaveSchemesEmployeesNotIncluded(leaveTypeItem.code, selectedCompany)
          .then((arr) => {
            let data = arr.map((item) => ({
              label: item.name,
              value: item.rowGuid,
              employeeid: item.employeeid ?? item.employeeID ?? item.employeeId,
            }));
            setNotIncluded(data);
          })
          .catch((err) => console.error("Error refreshing not included", err));

      } else {
        Swal.fire({
          title: "Error!",
          text: "Your operation failed. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else {
      let errorMessage =
        "There are validation errors or missing selections. Please check your inputs.";

      if (selectedLeaveType == "" || selectedLeaveType == null)
        errorMessage += " Not leave type selected";
      else if (selectedRule === null) errorMessage += " Not rule selected";
      else if (selectedExp === "")
        errorMessage += " Not parameter experience selected";
      else if (ruleValue == "" || valueError != "")
        errorMessage += " Rule value is empty";
      else if (leaveUnitsError != "" || leaveUnits == "")
        errorMessage += "Leave units error: " + leaveUnitsError;
      else if (selectedWorkUnit === null || selectedWorkUnit === "")
        errorMessage += "Work Units error: " + leaveUnitsError;
      else if (valueError != "" || ruleValue == "")
        errorMessage += " Value error: " + valueError;
      // else if (boundaryError != "" || boundary == "") {
      //   errorMessage += " Boundary error: " + boundaryError;

      // } else if (showCF && (maxcfError != "" || maxcf == "")) {
      //   errorMessage += " Max CF error: " + maxcfError;
      // } else if (total1 === "" || total1 === null)
      //   errorMessage += " Total 1 error: " + maxcfError;
      // else if (total2 === "" || total2 === null)
      //   errorMessage += " Total 2 error: " + maxcfError;



      // Optionally, display an error message using SweetAlert2
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const RenderPeople = ({ item }) => {
    const { getEmployeePhoto } = useCompany();
    const [photoUri, setPhotoUri] = useState(null);

    useEffect(() => {
      if (item?.employeeid) {
        getEmployeePhoto(item.employeeid)
          .then((uri) => {
            if (uri) setPhotoUri(uri);
          })
          .catch(() => { });
      }
    }, [item?.employeeid]);
    return (
      <View style={styles.rowItem}>
        <Image
          source={
            photoUri
              ? { uri: photoUri }
              : { uri: `data:image/png;base64,${DEFAULTPROFILE}` }
          }
          style={styles.employeePhotograph}
        />
        <View style={{ marginLeft: 10 }}>
          <Text style={styles.nameText}>{item.label}</Text>
        </View>
      </View>
    );
  };

  const startsWithFilter = (label, term) => {
    const name = (label ?? "").trim().toLowerCase();
    const q = (term ?? "").trim().toLowerCase();
    if (!q) return true;
    return name.startsWith(q);
  };

  return (
    <SafeAreaView style={[styles.mainView, { padding: 0, marginLeft: "3%" }]}>
      <ScrollView contentContainerStyle={styles.scrollViewContent}>
        <CustomButton
          onPress={() => postRecreateLeaveAnalysisForEmployees(selectedCompany)}
          text={t("common:recreateLeavesForCurrentYear")}
          type="BUTTON_SAVE"
          isGradient={true}
        />
        <SafeAreaView style={common.divider} />
        <View
          style={{ paddinng: "1%", marginTop: "2%", alignItems: "flex-start" }}
        >
          <CustomLabel value={t("common:Types")} type="SUBTITLE" />
        </View>
        <SafeAreaView style={[styles.dropdqownView, { zIndex: 5 }]}>
          <CustomDropDownWithIcons
            type="FULL"
            defValue={selectedLeaveType}
            options={leaveTypeOptions}
            setValue={setSelectedLeaveType}
          />
        </SafeAreaView>
        <SafeAreaView style={{ marginTop: "2%", zIndex: 2 }}>
          <View style={styles.row}>
            {/* Rules Container */}
            <View style={{ flex: 1 }}>
              <View style={{ zIndex: 4000, elevation: 4000 }}>
                <CustomLabel value={t("common:Rules")}
                  align="flex-start"
                  type="AVAILABLEUSED_SECONDARY" />
                <CustomDropDownWithIcons
                  type="FULL"
                  defValue={selectedRule}
                  options={ruleOptions}
                  setValue={setSelectedRule}
                  zIndex={4000}
                />
              </View>
              <View style={{ zIndex: 3000, elevation: 3000 }}>
                <CustomLabel value={t("common:params")}
                  align="flex-start"
                  type="AVAILABLEUSED_SECONDARY" />

                <CustomDropDownWithIcons
                  type="FULL"
                  defValue={selectedExp}
                  options={expOptions}
                  setValue={setSelectedExp}
                  zIndex={3000}
                />
              </View>

              <View style={{ zIndex: 2000, elevation: 2000 }}>
                <CustomLabel value={t("common:value")}
                  align="flex-start"
                  type="AVAILABLEUSED_SECONDARY" />
                <CustomInput
                  type="MAININPUT"
                  value={ruleValue}
                  editable={true}
                  setValue={(value) => onChangeRuleValue(value)}
                />
              </View>

              <View style={{ zIndex: 1000, elevation: 1000 }}>
                <CustomLabel value={t("common:leaveUnitNumber")}
                  type="AVAILABLEUSED_SECONDARY"
                  align="flex-start"
                />
                <CustomInput
                  type="MAININPUT"
                  value={leaveUnits}
                  editable={true}
                  setValue={(leavUnits) => onChangeLeaveUnits(leavUnits)}
                />
              </View>

              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  zIndex: 2,
                  paddingLeft: "2%",
                  marginRight: "5%",
                }}
              >
                <CustomLabel
                  value={t("common:workunits")}
                  align="flex-start"
                  type="AVAILABLEUSED_SECONDARY"
                />
                <View
                  style={{
                    flex: 1,
                    height: "100%",
                    justifyContent: "flex-start",
                  }}
                >
                  <View style={{}}>
                    <CustomDropDownWithIcons
                      type="FULL"
                      defValue={selectedWorkUnit}
                      options={workUnitsOptions}
                      setValue={setSelectedWorkUnit}
                    />
                  </View>
                </View>
              </View>
              <SafeAreaView
                style={{
                  marginBottom: "2%",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <CustomButton
                  onPress={() => setShowAdvancedOptions(!showAdvancedOptions)}
                  onPressIn={() => setButtonStyle(styles.buttonActive)}
                  onPressOut={() => setButtonStyle(styles.buttonCriteria)}
                  text={
                    showAdvancedOptions ? "Hide Options" : "Advanced Options"
                  }
                  type='BUTTON_ADD'
                />
              </SafeAreaView>
              {showAdvancedOptions && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    paddingLeft: "2%",
                    marginRight: "5%",
                  }}
                >
                  <CustomLabel
                    // Adjusted flex value
                    value={t("common:boundary")}
                    type="SUBTITLE"
                  />
                  <View
                    style={{
                      flex: 1,
                      height: "100%",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CustomInput
                      // Adjusted flex value
                      type="LOCATIONS"
                      value={boundary}
                      setValue={(bound) => onChangeBoundary(bound)}
                      editable={true}
                      keyboardType="numeric"
                    />
                  </View>
                </View>
              )}
              {showAdvancedOptions && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    paddingLeft: "2%",
                    marginRight: "5%",
                  }}
                >
                  <CustomLabel
                    // Adjusted flex value
                    value={t("common:Total1")}
                    type="SUBTITLE"
                  />
                  <View
                    style={{
                      flex: 1,
                      height: "100%",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CustomInput
                      // Adjusted flex value
                      type="LOCATIONS"
                      value={total1}
                      setValue={(total) => onChangeTotal(total, 1)}
                      editable={true}
                      keyboardType="numeric"
                    />
                  </View>
                </View>
              )}
              {showAdvancedOptions && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",

                    paddingLeft: "2%",
                    marginRight: "5%",
                  }}
                >
                  <CustomLabel
                    // Adjusted flex value
                    value={t("common:Total2")}
                    type="SUBTITLE"
                  />
                  <View
                    style={{
                      flex: 1,
                      height: "100%",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CustomInput
                      // Adjusted flex value
                      type="LOCATIONS"
                      value={total2}
                      setValue={(total) => onChangeTotal(total, 2)}
                      editable={true}
                      keyboardType="numeric"
                    />
                  </View>
                </View>
              )}

              {showCF && showAdvancedOptions && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",

                    paddingLeft: "2%",
                    marginRight: "5%",
                  }}
                >
                  <CustomLabel
                    // Adjusted flex value
                    value={t("common:maxcf")}
                    type="SUBTITLE"
                  />
                  <View
                    style={{
                      flex: 1,
                      height: "100%",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CustomInput
                      // Adjusted flex value
                      type="LOCATIONS"
                      value={maxcf}
                      setValue={(val) => onChangeMaxcf(val)}
                      editable={true}
                      keyboardType="numeric"
                    />
                  </View>
                </View>
              )}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",

                  paddingLeft: "2%",
                  marginRight: "5%",
                }}
              >
              </View>
              {/* Add more views as needed within the Rules container */}
            </View>
            {/* //Existing GetLeaveSchemes */}
            <View
              style={{
                flex: 3,
                alignContent: "flex-start",
              }}
            >
              <View>
                <CustomLabel
                  value={t("common:existingschemes")}
                  type="SUBTITLE"
                />
              </View>
              {changedRows.size > 0 && (
                <View style={{ marginVertical: "1%", flexDirection: "row", justifyContent: "flex-start" }}>
                  <CustomButton
                    onPress={handleSaveChanges}
                    text={isSaving ? "Saving..." : "Save Changes"}
                    type="BUTTON_SAVE"
                    isGradient={true}
                    disabled={isSaving}
                  />
                  <View style={{ marginLeft: 8 }}>
                    <CustomButton
                      onPress={handleCancelChanges}
                      text={"Cancel"}
                      type="BUTTON_CANCEL"
                      disabled={isSaving}
                    />
                  </View>
                </View>
              )}

              <View style={[styles.teamContainer, { overflow: "hidden" }]}>
                <ScrollView
                  style={{ flex: 1, maxHeight: 700 }}
                  nestedScrollEnabled={true}
                  contentContainerStyle={{ flexGrow: 1, flexWrap: "nowrap" }}
                  horizontal={true}
                  showsHorizontalScrollIndicator={true}
                >
                  <SafeAreaView>
                    <FlatList
                      numColumns={1}
                      scrollEnabled={true}
                      showsHorizontalScrollIndicator={true}
                      data={leaveSchemeParams}
                      renderItem={({ item, index }) => renderData(item, index)}
                      ListHeaderComponent={
                        leaveSchemeParams.length > 0 ? (
                          <SafeAreaView style={[common.listTitle, { marginHorizontal: 10 }]}>
                            <SafeAreaView style={[styles.row, { alignItems: "center" }]}>
                              <View style={{ flex: 2, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:criteria")} type="SUBTITLE" />
                              </View>
                              <View style={{ flex: 2, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:Rule")} type="SUBTITLE" />
                              </View>
                              <View style={{ width: 120, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:value")} type="SUBTITLE" />
                              </View>
                              {showCF && (
                                <View style={{ width: 120, marginHorizontal: 10 }}>
                                  <CustomLabel value={t("common:maxcf")} type="SUBTITLE" />
                                </View>
                              )}
                              <View style={{ width: 120, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:workunits")} type="SUBTITLE" />
                              </View>
                              <View style={{ width: 120, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:shortleavemax")} type="SUBTITLE" />
                              </View>
                              <View style={{ width: 120, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:shortleavetotal")} type="SUBTITLE" />
                              </View>
                              <View style={{ width: 120, marginHorizontal: 10 }}>
                                <CustomLabel value={t("common:totalleavemax")} type="SUBTITLE" />
                              </View>
                              {/* spacer to match the trash icon button  */}
                              <View style={{ width: 50 }} />
                            </SafeAreaView>
                          </SafeAreaView>
                        ) : null
                      }
                      keyExtractor={(_item, index) => index.toString()}
                    />
                  </SafeAreaView>
                </ScrollView>
              </View>
            </View>
          </View>
        </SafeAreaView>
        <SafeAreaView>
          <SafeAreaView style={{ marginBottom: "2%", flexDirection: "row", justifyContent: "flex-start" }}>
            <CustomButton
              onPress={() => setShowCriteria(!showCriteria)}
              onPressIn={() => setButtonStyle(styles.buttonActive)}
              onPressOut={() => setButtonStyle(styles.buttonCriteria)}
              text={showCriteria ? "Hide Criteria" : "Additional Criteria"}
              type='BUTTON_ADD'
            />
          </SafeAreaView>
          {showCriteria && (
            <View style={styles.criteriaView}>
              <View
                style={{ flexDirection: "row", marginRight: "5%", flex: 1 }}
              >
                <View style={{ zIndex: 1, flex: 0.3 }}>
                  <View>
                    <CustomLabel
                      // Adjusted flex value
                      value={t("common:Criteria")}
                      type="SUBTITLE"
                    />
                  </View>
                  <CustomDropDownWithIcons
                    type="FULL"
                    defValue={selectedCriterion}
                    options={criteriaOptions}
                    setValue={setSelectedCriterion}
                  />
                </View>
                <View style={{ zIndex: 2, flex: 0.3, marginRight: 0 }}>
                  <View>
                    <CustomLabel
                      // Adjusted flex value
                      value={t("common:Value")}
                      type="SUBTITLE"
                    />
                  </View>
                  <CustomDropDownWithIcons
                    type="FULL"
                    defValue={selectedCriteriaFiltering}
                    options={criteriaFilteringOptions}
                    setValue={setSelectedCriteriaFiltering}
                  />
                </View>
                <View
                  style={{
                    flex: 0.1,
                    marginTop: "2%",
                    marginLeft: 0,
                    flexDirection: "row",
                    alignItems: "flex-start",
                  }}
                >
                  <CustomButton
                    onPress={applyFiltering}
                    text={"Apply Filter"}
                    type="BUTTON_SAVE"
                    isGradient={true}
                  />
                </View>
              </View>
            </View>
          )}
          {showCriteria && (
            <View
              style={{
                maxHeight: 120,
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginTop: "3%",
                zIndex: 0,
              }}
            >
              <View
                style={{
                  flex: 0.5,
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  zIndex: 0,
                }}
              >
                <View style={{ flex: 1 }}>
                  <View style={{ marginBottom: "2%" }}>
                    <CustomLabel
                      value={t("common:appliedcriteria")}
                      type="SUBTITLE"
                    />
                  </View>
                  <TextInput
                    style={{
                      borderWidth: 1,
                      borderColor: "#ccc",
                      padding: 10,
                      height: 60, // Adjust height for multiline
                      textAlignVertical: "top", // Ensure text starts at the top
                      borderRadius: 10,
                    }}
                    value={appliedFiltersStr}
                    onChangeText={setAppliedFiltersStr}
                    editable={true}
                    multiline={true} // Enable multiline input
                  />
                </View>
              </View>
            </View>
          )}
          <View style={{ flexDirection: "row", justifyContent: "flex-start", marginVertical: "2%" }}>
            <CustomButton
              onPress={handleSubmit}
              text={"Submit Scheme"}
              type="BUTTON_SAVE"
              isGradient={true}
            />
          </View>
          <View style={common.divider} />
          <View style={styles.row}>
            {/* Included Twice */}
            <Card style={[common.cardstyle, { flex: 1, marginHorizontal: 5 }]}>
              <CustomLabel value={t("common:twice")} type="SUBTITLE" />
              <View style={{ marginHorizontal: 10 }}>
                <CustomInput
                  editable={true}
                  placeholder={`${t('common:search')}...`}
                  value={searchTermTwice}
                  setValue={setSearchTermTwice}
                  type="MAININPUT"
                />
              </View>
              <Card.Content>
                <View style={[styles.teamContainer, { overflow: "hidden" }]}>
                  <ScrollView
                    style={{ flex: 1, maxHeight: 700 }}
                    nestedScrollEnabled={true}
                    contentContainerStyle={{ flexGrow: 1 }}
                  >
                    <FlatList
                      horizontal={false}
                      scrollEnabled={true}
                      showsHorizontalScrollIndicator={false}
                      data={includedTwice.filter(item =>
                        startsWithFilter(item.label, searchTermTwice)
                      )}
                      renderItem={({ item, index }) => (
                        <RenderPeople item={item} index={index} />
                      )}
                      keyExtractor={(_item, index) => index.toString()}
                    />
                  </ScrollView>
                </View>
              </Card.Content>
            </Card>

            <View style={common.verticalDivider} />

            {/* Not Included */}
            <Card style={[common.cardstyle, { flex: 1, marginHorizontal: 5 }]}>
              <CustomLabel value={t("common:notIncluded")} type="SUBTITLE" />
              <View style={{ marginHorizontal: 10 }}>
                <CustomInput
                  editable={true}
                  placeholder={`${t('common:search')}...`}
                  value={searchTermNotIncluded}
                  setValue={setSearchTermNotIncluded}
                  type="MAININPUT"
                />
              </View>
              <Card.Content>
                <View style={[styles.teamContainer, { overflow: "hidden" }]}>
                  <ScrollView
                    style={{ flex: 1, maxHeight: 700 }}
                    nestedScrollEnabled={true}
                    contentContainerStyle={{ flexGrow: 1 }}
                  >
                    <FlatList
                      horizontal={false}
                      scrollEnabled={true}
                      showsHorizontalScrollIndicator={false}
                      data={notIncluded.filter(item =>
                        startsWithFilter(item.label, searchTermNotIncluded)
                      )}
                      renderItem={({ item, index }) => (
                        <RenderPeople item={item} index={index} />
                      )}
                      keyExtractor={(_item, index) => index.toString()}
                    />
                  </ScrollView>
                </View>
              </Card.Content>
            </Card>
          </View>
        </SafeAreaView>
      </ScrollView >
    </SafeAreaView >
  );
};

const makeStyles = (colors, width, height) =>
  StyleSheet.create({
    label: {
      fontSize: 14,
      textAlign: "left", // Ensure text is aligned to the left
    },
    scrollViewContent: {
      flexGrow: 1,
      padding: 0,
    },

    column: {
      flex: 1,
      alignItems: "center",
      fontSize: "10",
      marginRight: "4%",
      marginHorizontal: 10,
    },
    rightAlignedContainer: {
      flexDirection: "row",
      justifyContent: "space-between", // Space between items
      alignItems: "flex-end",
      width: "auto", // Adjust width as needed
    },
    dropdownView: {
      width: "70%",
      flex: 1,
    },
    mainView: {
      flex: 1,
    },
    teamContainer: {
      marginHorizontal: 10,
    },
    criteriaView: {
      zIndex: 3,
      maxHeight: 120,
      flexDirection: "row",
    },
    icon: {},
    subMain: {
      borderRadius: 35,
      elevation: Platform.OS === "web" && width > 992 ? 3 : 0,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.1,
      width: "100%",
      alignContent: "center",
      borderWidth: 0,
    },
    rowView: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "center",
      alignContent: "center",
    },
    ruleView: {},
    paramsView: {},

    cardStyleBranch: {
      marginBottom: 0,
      marfinTop: 0,
      borderRadius: 0,
      elevation: 5,
      //shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      //shadowRadius: 5,
      backgroundColor: colors.background_card,
      width: "35%",
      alignSelf: "left",
      justifyContent: "flex-start",
    },
    input: {
      borderColor: colors.inputBorder,
      borderRadius: 5,
      padding: 1,
      margin: 0,
      backgroundColor: colors.inputBackground,
    },
    item: {
      flex: 1,
      marginHorizontal: 5,
      margin: 0,
    },
    buttonSelected: {
      backgroundColor: colors.buttons,
      margin: 10,
      flexDirection: Platform.OS !== "web" ? "column" : "row",
      borderRadius: 20,
      borderWidth: 2,
      borderColor: colors.buttons_submit,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
    },
    error: {
      color: colors.validation_error,
      alignSelf: "center",
      fontSize: 14,
    },
    Button_SELECTED: {
      margin: 10,
      borderRadius: 5,
      borderWidth: 2,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      backgroundColor: colors.background_card,
      borderColor: colors.buttons_submit,
    },
    backButton: {
      alignSelf: "flex-end",
    },
    innerView: {
      flex: 1,
    },
    branchesView: {
      flexDirection: "row",
      height: "100%",
    },
    fullHeight: {
      height: "95%",
    },
    fullWidth: {
      height: "78%",
    },
    locationView: {
      width: "85%",
      height: "100%",
    },
    functionalityButtons: {
      justifyContent: "flex-end",
    },
    buttons: {
      padding: 0,
      width: "10%",

      marginBottom: 0,
      alignSelf: "flex-end",
    },
    loader: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "4%",
    },

    button: {
      marginHorizontal: 5,
      padding: 1,
      borderRadius: 5,
      backgroundColor: "#A0A2FF",
      alignItems: "center",
      justifyContent: "center",
    },
    functionalityButtons: {
      justifyContent: "flex-end",
      paddingTop: 70,
    },
    attachmentNameText: {
      fontSize: 16,
      color: colors.text_primary,
    },
    buttons: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "flex-end",
      width: "50%",
      height: "50%",
      alignSelf: "flex-end",
    },
    listWrapper: {
      felx: 1,
      padding: Platform.OS === "web" ? 10 : 1,
      marginBottom: 0,
      height: "100%",
    },
    buttonCriteria: {
      backgroundColor: "#007bff",
      padding: 10,
      borderRadius: 5,
      alignItems: "center",
    },
    buttonActive: {
      backgroundColor: "#0056b3",
      padding: 10,
      borderRadius: 5,
      alignItems: "center",
    },
    buttonText: {
      color: "#fff",
      fontSize: 16,
    },
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingBottom: 10,
      borderBottomWidth: 1,
      borderBottomColor: "#ccc",
    },
    headerItem: {
      flex: 1,
      textAlign: "center",
      fontWeight: "bold",
    },
    itemContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 10,
      borderBottomWidth: 1,
      borderBottomColor: "#ccc",
    },
    // teamItem: {
    //   // flex: 1,
    //   flexDirection: "row",
    //   margin: 10,
    //   marginLeft: 15,
    //   padding: Platform.OS === "web" ? 10 : 1,
    //   paddingLeft: 10,
    //   justifyContent: "center",
    //   alignItems: "center",
    //   backgroundColor: colors.background_card,
    //   borderRadius: 35,
    //   shadowColor: colors.card_line,
    //   shadowOffset: { width: 0, height: 0 },
    //   shadowOpacity: 0.1,
    //   shadowRadius: 5,
    // },
    rowItem: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 5,
      paddingHorizontal: 12,
      marginVertical: 2,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: "#e0e0e0",
    },
    nameText: {
      fontSize: 14,
      fontWeight: "500",
    },
    employeePhotograph: {
      width: 30,
      height: 30,
      borderRadius: 15,
      borderWidth: 1,
      borderColor: "#ccc",
    },
    row: {
      flex: 1,
      flexDirection: "row",
    },
  });
export default HRAdminLeaveSchemeScreen;
